export default `
  query productSpecificationDetails(
      $filter: ProductAttributeFilterInput
  ) {
        products(filter: $filter) {
            items {
                product_specification_details
            }
        }
    }
`;
